import { drawerAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const mobileNav = definePartsStyle({
  dialog: {
    top: "0px !important"
  },
  overlay: {
     top: "0px"
  },
  dialogContainer:{
    top: "0px"
  }
})

export const drawerTheme = defineMultiStyleConfig({
  variants: { mobileNav },
})

